"use client";

import { StepKey } from "@/components/sell/types/form";
import { trackEvent } from "@/utils/analytics/track-event";

interface SellerListingTrackingProps {
	action: "view" | "submit";
	stepKey?: StepKey | "home";
	listingId?: string;
}

export function trackSellerListing({ action, stepKey = "home", listingId }: SellerListingTrackingProps) {
	if (action === "view") {
		// Track seller listing page view
		trackEvent({
			google: {
				event: "page_view",
				options: {
					page_title: `Seller Listing Page - ${stepKey}`,
					page_location: window.location.href,
				},
			},
			matomo: {
				event: `view-listing-page_${stepKey}`,
				options: {
					category: "seller",
				},
			},
		});
	} else if (action === "submit") {
		// Track Google Ads conversion for seller listing page
		if (typeof window !== "undefined" && window.gtag) {
			window.gtag("event", "conversion", {
				send_to: "AW-881882540/TUztCJDDmcsDELfPrrMB",
				value: 1.0,
				currency: "INR",
			});
		}

		// Track form submission
		trackEvent({
			facebook: {
				event: "SubmitApplication",
				options: {
					content_name: "Seller Listing Submitted",
					content_category: `seller_listing_${stepKey}`,
				},
			},
			google: {
				event: "form_submit",
				options: {
					form_id: `seller_listing_form_${stepKey}`,
					custom_parameters: {
						listing_id: listingId,
					},
				},
			},
			matomo: {
				event: `submit-listing_${stepKey}`,
				options: {
					category: "seller",
				},
			},
		});
	}
}
